import "babel-polyfill";
import "isomorphic-fetch";
import React from "react";
import "./index.scss";
import "utils/thirdPartyScripts";
import App from "./App";
import { missionId } from "utils/urls";

import { createRoot, hydrateRoot } from "react-dom/client";

// Apply the mission as a data attribute on <body> so CSS can apply
// mission-specific theme overrides at runtime without a separate build.
document.body.setAttribute("data-mission", missionId || "sainsburys");

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}
